import helpers from './helpers';

export default {
  fromStore(tasks, ganttInstance) {
    ganttInstance.batchUpdate(() => {
      const parentsToRefresh = [];

      tasks.forEach(task => {
        if (!ganttInstance.isTaskExists(task.parent)) {
          return;
        }

        parentsToRefresh.push(task.parent);

        if (Object.prototype.hasOwnProperty.call(task, 'open')) {
          Object.assign(task, { $open: task.open });
        }

        ganttInstance.silent(() => {
          ganttInstance.addTask({ ...task, calendar_id: +task.gantt_id }, task.parent, task.sortorder);

          if (!ganttInstance.$data.tasksStore.fullOrder.includes(task.id)) {
            ganttInstance.$data.tasksStore.fullOrder.push(task.id);
          }
        });
      });

      helpers.updateButtonsInTasks(ganttInstance, parentsToRefresh);
    });
  },

  fromGantt(tasks, ganttInstance) {

  },
};
